// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu__subcategories[data-v-4675f54c]{transform:translateZ(0);will-change:transform,opacity}.subcategories__items[data-v-4675f54c]{overflow-y:auto;-webkit-overflow-scrolling:touch;scroll-behavior:smooth}.subcategories__items.safari[data-v-4675f54c]{transform:translateZ(0)}img[data-v-4675f54c]{image-rendering:-webkit-optimize-contrast;image-rendering:optimize-contrast}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
